import React from 'react'
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { updateChartConfig } from '../../../../reducer/chart.reducer'
import { selectMultiStrikeStatusLineSettings } from '../../../../selectors/chart'
import { StatusLineSettings } from '../../../chartV2/chart.typings'
import {
    chartSettingsSectionDividerSx,
    chartSettingsSectionTitleSx,
} from '../../../chartSettings/chartSettingsLayout'

type Props = {
    viewKey: string
}

const checkboxSx = {
    ml: 0,
    '& .MuiFormControlLabel-label': { fontSize: '14px' },
}

const OiStatusLineSettings = ({ viewKey }: Props) => {
    const dispatch = useDispatch()
    const statusLineSettings = useSelector(selectMultiStrikeStatusLineSettings(viewKey))

    const updateSettings = (partial: Partial<StatusLineSettings>) => {
        dispatch(updateChartConfig({
            viewKey,
            config: {
                statusLineSettings: {
                    ...statusLineSettings,
                    ...partial,
                },
            },
            createIfAbsent: false,
        }))
    }

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, field: keyof StatusLineSettings) => {
        updateSettings({ [field]: event.target.checked })
    }

    return (
        <Box>
            <Typography variant="subtitle1" sx={chartSettingsSectionTitleSx}>
                SYMBOL
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(statusLineSettings.logo ?? true)}
                            onChange={(e) => handleCheckboxChange(e, 'logo')}
                        />
                    }
                    label="Logo"
                    sx={checkboxSx}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(statusLineSettings.showSymbolName ?? true)}
                            onChange={(e) => handleCheckboxChange(e, 'showSymbolName')}
                        />
                    }
                    label="Title"
                    sx={checkboxSx}
                />
            </FormGroup>
            <Typography variant="subtitle1" sx={{ ...chartSettingsSectionTitleSx, ...chartSettingsSectionDividerSx }}>
                STRIKE LINES
            </Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={
                            !!((statusLineSettings.indicatorTitle ?? true) && (statusLineSettings.indicatorValues ?? true))
                        }
                        onChange={(e) => {
                            const checked = e.target.checked
                            updateSettings({ indicatorTitle: checked, indicatorValues: checked })
                        }}
                    />
                }
                label="Strike metadata"
                sx={{
                    ...checkboxSx,
                    display: 'block',
                    width: '100%',
                }}
            />
        </Box>
    )
}

export default OiStatusLineSettings
